import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, of, throwError, pipe } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { URLS } from '../constants/URLS';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobaldataService {

  private watchListSubject = new BehaviorSubject<any[]>([]);
  private subscriptionsSubject = new BehaviorSubject<any[]>([]);
  private userDataLoadedSubject = new BehaviorSubject<boolean>(false);
  
  public watchList$ = this.watchListSubject.asObservable();
  public subscriptions$ = this.subscriptionsSubject.asObservable();
  public userDataLoaded$ = this.userDataLoadedSubject.asObservable();
  
  constructor(
    private http: HttpClient     
  ) {}
  
  getGenreData() {
    let url;
    if(environment.baseUrl === 'https://dev.toqqer.com/'){
      url = 'https://dev.toqqer.com/cms/MasterDataController/getGenre'
    }else if(environment.baseUrl === 'https://toqqerstage.com/'){
      url = 'https://toqqerstage.com/cms-api/MasterDataController/getGenre'
    }else if(environment.baseUrl === 'https://toqqer.com/'){
      url = 'https://toqqer.com/cms-api/MasterDataController/getGenre'
    }else if(environment.baseUrl === 'https://api.homecinemaplus.tv/'){
      url = 'https://api.homecinemaplus.tv/cms-api/MasterDataController/getGenre'
    }
    return this.http.get<any[]>(url).pipe(
      catchError(err => {
        console.error('Failed to load genres', err);
        return throwError(() => err);
      })
    );
  }
}
